module.exports = __webpack_public_path__ + "1791188489487/fonts/WorkSans-Regular.a238b97.woff";